/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 12/15/2014
 * Time: 12:26 PM
 ***********************************************************************************************************
 **************************************** TAGS-CONTAINER INITIALIZE ****************************************
 ***********************************************************************************************************
 var tagsContainer = new TagsContainer({
        el: $(), // the TagsContainer container
        itemsComparator: function(item) { return item.id } , // comparator function or false for no sorting. default is by value (lower cased)
        enabled: true, // if the component is enabled or disabled. default is true
        tagCreationEnabled: true, // if the user can create new tags by clicking on the component container. default is true
        maxShownLines: 10, // max shown lines before the container gets scroll. 0 for un-limit.  default is 0
        inlineErrorText: "you must click Enter", // the text will be shown if the user blur the input without clicking Enter or Tab. if you don't want an error set it to "". default: "You should click Enter or Tab"
        inlineErrorBubbleZIndex: 10000, // if need to affect the inline error bubble zindex. default is Bubble.DEFAULT_ZINDEX (currently 1999)
        tagMaxWidth: "395px", // String with text represents what is the tag max-width before it gets ellipsis. "100%" for no ellipsis. default is "100%"
        placeholder: "placeholder", // String to be shown when there is no tags in the component. default is "".
        separator: "or", // default separator between tags. default is "".
        closeable: true, // default for tags are can closed. default is true
        items: [
            {
                id: 1,
                value: "Item 1",
                subText: "item description", // optional - will appear only in tooltip
                separator: "or", // optional - can be taken from component default option
                closeable: true, // optional - can be taken from component default option
            }
        ]
 });
 ***********************************************************************************************************
 ***********************************************************************************************************
 ***********************************************************************************************************
 *
 *
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var $ = require("jquery");
    var Marionette = require("marionette");
    var Logger = require("logger");
    var Bubble = require("ui/bubble/Bubble");
    var _ = require("underscore");

    //Template
    var template = require("ui/tags-container/templates/tagsContainer.tmpl");

    //List MVC
    var TagsContainerModel = require("ui/tags-container/js/models/TagsContainerModel");
    var TagItemView = require("ui/tags-container/js/views/TagItemView");
    //</editor-fold>

    var LINE_HEIGHT = 24;
    var HEIGHT_BUFFER = 6;

    var TRIGGERING = {
        FOCUS: "focus",
        BLUR: "blur",
        TAG_REMOVE: "tag:remove",
        INPUT_CREATE: "input:create",
        INPUT_ARROW: "input:arrow",
        INPUT_CHANGE: "input:change"
    };

    var THEME = {
        DEFAULT: "default-theme",
        NIGHT: "night-theme"
    };

    var TagsContainer = Marionette.CompositeView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        className: "tags-container-component",
        template: template,
        itemView: TagItemView,
        itemViewContainer: ".tags-wrapper",
        withUIComponents:true,
        tagInputIsFocused: false,
        ui: {
            tagsWrapper: ".tags-wrapper",
            tagsPlaceholder: ".tags-placeholder",
            tagCreationContainer: ".tag-creation-container",
            tagCreationSeparator: ".tag-creation-separator",
            tagCreationInput: ".tag-input"
        },
        events: {
            "click": "_onTagsContainerClick",
            "clickoutside": "_onTagsContainerClickOutside",
            "keydown .tag-input": "_onTagInputKeyDown",
            "keyup .tag-input": "_onTagInputKeyUp",
            "cut .tag-input": "_onTagInputValueChange",
            "paste .tag-input": "_onTagInputValueChange"
        },
        itemEventsOld: {
            "itemview:closeButtonClick": "_onItemCloseButtonClick"
        },
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function(options) {
            this._initialize(options);
        },
        itemViewOptions: function(model) {
            return this._itemViewOptions(model);
        },
        onRender: function() {
            this._onRender();
        },
        //</editor-fold>


        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        setFocus: function (options) {
            this._setFocus(options);
        },
        setBlur: function() {
            this._setBlur();
        },
        setError: function(isError, errorMsg) {
            this._setError(isError, errorMsg);
        },
        setInlineError: function(isError) {
            this._setInlineError(isError);
        },
        setEnabled: function(enabled) {
            this._setEnabled(enabled);
        },
        isEnabled: function() {
            return this._isEnabled();
        },
        addItem: function(item) {
            this._addItem(item);
        },
        removeItem: function(itemId) {
            this._removeItem(itemId);
        },
        clearItems: function() {
            this._setItems([]);
        },
        setItems: function(items) {
            this._setItems(items);
        },
        getItems: function() {
            return this._getItems();
        },
        setPlaceholder: function(placeholder) {
            this._setPlaceholder(placeholder);
        },
        discardInput: function() {
            this._onTagInputDiscard();
        },
        getInputValue: function() {
            return this._getInputValue();
        },
        setInputValue: function(value) {
            this._setInputValue(value);
        },
        clearInputValue: function () {
            this._clearInputValue();
        },
        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function (options) {
            this.logger = Logger.getLogger("TagsContainer");
            this.logger.info("Initializing TagsContainer", "TagsContainer:_initialize");
            this.model = _initTagsContainerModel(options);

            this.theme = _.has(options, "theme") ? options.theme : THEME.DEFAULT;
            this.container = options.container;
            this.collection = this.model.getItems();

            Marionette.bindEntityEvents(this, this, this.itemEventsOld);
        },
        _itemViewOptions: function(model) {
            return {
                model: model,
                tagMaxWidth: this.model.getTagMaxWidth(),
                tooltipAlign: this.model.getTooltipAlign()
            };
        },
        _onRender: function () {
            this.logger.info("Rendering TagsContainer", "TagsContainer:_onRender");

            this.$el.addClass(this.className);
            this.$el.addClass(this.theme);
            if (this.container) {
                this.container.append(this.$el);
            }

            this._updatePlaceholderVisibility();
            this._updateMaxShownLines();
            this._updateEnabled();

            this._bindEventsToData();
        },

        _bindEventsToData: function() {
            this.logger.debug("bind events to model and collection", "TagsContainer:_bindEventsToData");

            this.listenTo(this.collection, "add", this._updatePlaceholderVisibility);
            this.listenTo(this.collection, "remove", this._updatePlaceholderVisibility);
            this.listenTo(this.collection, "reset", this._updatePlaceholderVisibility);
            this.listenTo(this.model, "change:maxShownLines", this._updateMaxShownLines);
            this.listenTo(this.model, "change:enabled", this._updateEnabled);
            this.listenTo(this.model, "change:placeholder", this._updatePlaceholder);
        },

        _updatePlaceholder: function() {
            var placeholder = this.model.getPlaceholder();

            this.logger.debug("update placeholder text", "TagsContainer:_updatePlaceholder", {placeholder:placeholder});
            this.ui.tagsPlaceholder.text(placeholder);
        },

        _updatePlaceholderVisibility: function(forceState) {
            var hidePlaceholder = (this.model.getItems().size() > 0) || !_.isEmpty(this._getInputValue()) || this.tagInputIsFocused;
            if (_.isBoolean(forceState)) {
                hidePlaceholder = !forceState;
            }

            this.logger.debug("update placeholder visibility", "TagsContainer:_updatePlaceholderVisibility", {hidePlaceholder:hidePlaceholder});
            this.ui.tagsPlaceholder.toggleClass("hide", hidePlaceholder);
        },

        _updateMaxShownLines: function() {
            if (!this.model.getMaxShownLines()) {
                this.logger.debug("update max shown lines to auto", "TagsContainer:_updateMaxShownLines");
                this.$el.css("max-height", "auto");
            }
            else {
                var maxHeight = LINE_HEIGHT * this.model.getMaxShownLines() + HEIGHT_BUFFER;
                this.logger.debug("update max shown lines to " + maxHeight, "TagsContainer:_updateMaxShownLines");
                this.$el.css("max-height", maxHeight+"px");
            }
        },

        _updateEnabled: function() {
            var isEnabled = this.model.isEnabled();
            this.logger.debug("update enabled", "TagsContainer:_updateEnabled", {isEnabled:isEnabled});
            this.$el.toggleClass("disabled", !isEnabled);
        },

        _updateCreateTagVisibility: function(showCreateTag) {
            this.logger.debug("update create tag visibility", "TagsContainer:_updateCreateTagVisibility", {showCreateTag:showCreateTag});
            this.ui.tagCreationContainer.toggleClass("hide", !showCreateTag);

            var showTagCreationSeparator = showCreateTag && !_.isEmpty(this.model.get("separator")) && this.model.getItems().size() > 0;
            this.logger.debug("update create tag separator visibility", "TagsContainer:_updateCreateTagVisibility", {showTagCreationSeparator:showTagCreationSeparator});
            this.ui.tagCreationSeparator.toggleClass("hide", !showTagCreationSeparator);
        },

        _onTagsContainerClick: function() {
            this.logger.info("Tags container click", "TagsContainer:_onTagsContainerClick");
            this._setFocus();
        },

        _onTagsContainerClickOutside: function() {
            this.logger.debug("Tags container click outside", "TagsContainer:_onTagsContainerClickOutside");
            this._setBlur({isFromClickOutside:true});
        },

        _onTagInputKeyDown: function(event) {
            this.logger.debug("Tags container input key down", "TagsContainer:_onTagInputKeyDown");

            event.stopPropagation();
            var key = event.keyCode;

            if (key === $.ui.keyCode.UP || key === $.ui.keyCode.DOWN) {
                event.preventDefault();
                var isUp = (key === $.ui.keyCode.UP);
                this._onTagInputArrowPress(isUp);
            }

            if (key === $.ui.keyCode.ENTER || key === $.ui.keyCode.TAB) {
                event.preventDefault();
            }
        },

        _onTagInputKeyUp: function(event) {
            this.logger.debug("Tags container input key up", "TagsContainer:_onTagInputKeyUp");

            event.stopPropagation();
            var key = event.keyCode;

            if (key === $.ui.keyCode.ESCAPE) { // should be handled on key up in order to make sure we stop the event propagation on time.
                this._onTagInputDiscard();
                return;
            }

            if (key === $.ui.keyCode.ENTER || key === $.ui.keyCode.TAB) {
                this._onTagInputCreate();
                return;
            }

            this._onTagInputValueChange(event);
        },

        _onTagInputDiscard: function(event) {
            this.logger.debug("Tags container input discard", "TagsContainer:_onTagInputDiscard");

            this._clearInputValue();
            this._setBlur();
            this._setInlineError(false);
        },

        _onTagInputCreate: function(event) {
            this.logger.debug("Tags container input create", "TagsContainer:_onTagInputCreate");

            var inputValue = this._getInputValue();
            this.trigger(TRIGGERING.INPUT_CREATE, {"value": inputValue});
        },

        _onTagInputArrowPress: function(isUp) {
            this.logger.debug("Tags container arrow pressed", "TagsContainer:_onTagInputArrowPress", {isUp: isUp});
            this.trigger(TRIGGERING.INPUT_ARROW, {isUp: isUp});
        },

        _onTagInputValueChange: function(event) {
            var inputValue = this._getInputValue();
            this.logger.debug("Tags container input changed", "TagsContainer:_onTagInputValueChange", {inputValue: inputValue});
            this.trigger(TRIGGERING.INPUT_CHANGE, {"value": inputValue});
        },

        _onItemCloseButtonClick: function(itemView) {
            this.logger.info("Tags container item close clicked", "TagsContainer:_onItemCloseButtonClick");

            if (!this.model.isEnabled()) {
                return;
            }

            var itemModel = itemView.model;
            var itemId = itemModel.id;
            var itemValue = itemModel.getValue();

            this.logger.debug("Tags container item close clicked", "TagsContainer:_onItemCloseButtonClick",{id:itemId, itemValue:itemValue});

            this.model.removeItem(itemId);
            _.defer(_.bind(this._setBlur, this)); // on defer so it will take place after the listener of remove from collection is happened

            this.trigger(TRIGGERING.TAG_REMOVE, {"value": itemValue});
        },

        _setFocus: function(options) {
            this.logger.debug("Tags container focus", "TagsContainer:_setFocus");

            options = options || {};

            if (!this.model.isEnabled() || !this.model.isTagCreationEnabled()) {
                return;
            }

            this._setInlineError(false);
            this._showErrorBubble(true);
            this._updatePlaceholderVisibility(false);
            this._updateCreateTagVisibility(true);
            this.ui.tagCreationInput.focus();
            this.tagInputIsFocused = true;

            if (!options.silent) {
                var inputValue = this._getInputValue();
                this.trigger(TRIGGERING.FOCUS, {value:inputValue});
            }
        },

        _setBlur: function(options) {
            this.logger.debug("Tags container blur", "TagsContainer:_setBlur");

            options = options || {};

            if (options.isFromClickOutside && !this.tagInputIsFocused) {
                // do nothing if the user clicks outside but the input not in focus - in this case the user just clicks somewhere on the page and we dont want to remove the error
                // set error false only if the user clicks outside and the input was in focus - implicitly: the user actually blurs the input
                // or: someone ask for blur explicitly (so do what he wants :) - in this case "options.isFromClickOutside" is undefined and we move to "else"
            }
            else {
                this._setError(false);
            }
            this._setInlineError(true);

            this.ui.tagCreationInput.blur();
            this.tagInputIsFocused = false;
            this._updatePlaceholderVisibility();
            this._updateCreateTagVisibility(!_.isEmpty(this._getInputValue()));

            if (!options.silent) {
                this.trigger(TRIGGERING.BLUR);
            }
        },

        _addItem: function(item) {
            this.model.addItem(item);
        },

        _removeItem: function(itemId) {
            this.model.removeItem(itemId);
        },

        _setItems: function(items) {
            this.model.setItems(items);
        },

        _getItems: function() {
            return this.model.getItems().toJSON();
        },

        _setPlaceholder: function(placeholder) {
            this.model.setPlaceholder(placeholder);
        },

        _setEnabled: function(enabled) {
            this.model.setEnabled(enabled);
        },

        _isEnabled: function() {
            return this.model.isEnabled();
        },

        _setError: function(isError, errorMsg) {
            this.logger.debug("Tags container set error", "TagsContainer:_setError", {isError:isError, errorMsg:errorMsg});
            if (isError) {
                this.model.setErrorText(errorMsg);
                this.$el.addClass("error");
            }
            else {
                this.model.setErrorText(null);
                this.$el.removeClass("error");
                this._showErrorBubble(false);
            }
        },

        _showErrorBubble: function(showBubble) {
            if (this.uiComponents.tagsContainerError) {
                this.uiComponents.tagsContainerError.close(true);
            }

            if (showBubble && !_.isEmpty(this.model.getErrorText())) {
                this.uiComponents.host$.createAndRender("tagsContainerError", {
                    type: Bubble,
                    options: {
                        targetControl: this.$el,
                        text: this.model.getErrorText(),
                        position: Bubble.POSITION.RIGHT,
                        icon: Bubble.ICON.ERROR,
                        showCloseButton: false,
                        preventCloseOnBubbleMouseEnter: false
                    }
                });
            }
        },

        _setInlineError: function(isError) {
            this.logger.debug("Tags container set inline error", "TagsContainer:_setInlineError", {isError:isError});

            if (isError && !_.isEmpty(this._getInputValue()) && !_.isEmpty(this.model.getInlineErrorText())) {
                this.logger.debug("Tags container show inline error", "TagsContainer:_setInlineError");
                // we show the error once, but leave the error class until it's fixed.
                // so the first time the user blurs - there is no error class - we add the class and show the error
                // the second time he blurs - there is error class - so we just hide the error and leave the class
                if (!this.ui.tagCreationInput.hasClass("error")) {
                    this.logger.debug("Tags container show inline error bubble", "TagsContainer:_setInlineError");
                    this.ui.tagCreationInput.addClass("error");
                    this._showInlineErrorBubble(true);
                }
                else {
                    this.logger.debug("Tags container remove inline error bubble", "TagsContainer:_setInlineError");
                    this._showInlineErrorBubble(false);
                }
            }
            else {
                this.logger.debug("Tags container remove inline error", "TagsContainer:_setInlineError");
                this.ui.tagCreationInput.removeClass("error");
                this._showInlineErrorBubble(false);
            }
        },

        _showInlineErrorBubble: function(showBubble) {
            if (this.uiComponents.inlineError) {
                this.uiComponents.inlineError.close(true);
            }

            if (showBubble && !_.isEmpty(this.model.getInlineErrorText())) {
                this.uiComponents.host$.createAndRender("inlineError", {
                    type: Bubble,
                    options: {
                        text: this.model.getInlineErrorText(),
                        targetControl: this.ui.tagCreationInput,
                        position: Bubble.POSITION.BOTTOM,
                        align: Bubble.ALIGN.LEFT,
                        icon: Bubble.ICON.ERROR,
                        showCloseButton: false,
                        preventCloseOnBubbleMouseEnter: false,
                        zIndex: this.model.getInlineErrorBubbleZIndex() || Bubble.DEFAULT_ZINDEX
                    }
                });
            }
        },

        _getInputValue: function() {
            // Replace &nbps with regular whitespace, since we use 'contenteditable' span
            var re = new RegExp(String.fromCharCode(160), "g");
            var text = this.ui.tagCreationInput.text();
            return text.replace(re, " ");
        },
        _clearInputValue: function() {
            this._setInputValue("");
        },
        _setInputValue: function(value) {
            this.ui.tagCreationInput.text(value);
        }
        //</editor-fold>

    });

    ////////////////////////////////////////////////////////////////////////////
    //Utility functions fold that does not need "this"
    ////////////////////////////////////////////////////////////////////////////
    function _initTagsContainerModel(options) {
        var model = new TagsContainerModel();

        if (_.has(options, "itemsComparator")) {
            model.setItemsComparator(options.itemsComparator);
        }

        if (_.has(options, "enabled")) {
            model.setEnabled(options.enabled);
        }

        if (_.has(options, "tagCreationEnabled")) {
            model.setTagCreationEnabled(options.tagCreationEnabled);
        }

        if (_.has(options, "maxShownLines")) {
            model.setMaxShownLines(options.maxShownLines);
        }

        if (_.has(options, "inlineErrorText")) {
            model.setInlineErrorText(options.inlineErrorText);
        }

        if (_.has(options, "inlineErrorBubbleZIndex")) {
            model.setInlineErrorBubbleZIndex(options.inlineErrorBubbleZIndex);
        }

        if (_.has(options, "tagMaxWidth")) {
            model.setTagMaxWidth(options.tagMaxWidth);
        }

        if (_.has(options, "placeholder")) {
            model.setPlaceholder(options.placeholder);
        }

        if (_.has(options, "separator")) {
            model.setSeparator(options.separator);
        }

        if (_.has(options, "closeable")) {
            model.setCloseable(options.closeable);
        }

        if (_.has(options, "tooltipAlign")) {
            model.setTooltipAlign(options.tooltipAlign);
        }

        if (_.has(options, "items")) {
            model.setItems(options.items);
        }
        else {
            model.setItems([]);
        }

        return model;
    }

    TagsContainer.TRIGGERING = TRIGGERING;
    TagsContainer.THEME = THEME;

    return TagsContainer;

});
